import React, { useRef, useEffect, useState } from 'react'
import useShopStatus from '@RootCommon/hooks/useShopStatus'
import { getHost, jumpTo } from '@RootCommon/utils'
import { getSafeArea } from '@RootCommon/utils/h5PC'
import Affix from '@RootCommon/components/Affix'
import Icon from '@roo/roo/Icon'
import { SAILORPARTNER_SHOP_CHOICE } from '@RootCommon/constants/nativeAppUrls'
import { owlReportMetrics } from '@RootCommon/utils/owl'
import { CUSTOM_METRICS } from '../../constant'
import { lxMC } from '@/common/utils/lx'
import { LvPoint } from '../../constant'
import { isRTL, getLoginShopid } from '@RootCommon/utils'
import raf from 'raf'

type TProps = {
  container?: HTMLElement | string
}

// let shopCode = '测试分店测试分店测试分店测试分店测试分店测试分店测试分店测试分店'
// shopCode = '测试分店'
// shopCode = ''

export default ({ container }: TProps) => {
  const ScrollDomRef = useRef<any>(null)
  // const BorderRadiusDomRef = useRef<any>(null)
  const ShopNameDomRef = useRef<any>(null)
  const StatusBoxDomRef = useRef<any>(null)
  const StatusTagDomRef = useRef<any>(null)
  const HeightDomRef = useRef<any>(null)
  const StatusDomRef = useRef<any>(null)
  const ShpoIdDomRef = useRef<any>(null)
  const [showCodeOnly, setShowCodeOnly] = useState(false)

  const safeTop = getSafeArea().top || 44

  const {
    extText,
    statusText,
    classname: statusClassname,
    shopStatusInfo,
    updateShopInfo,
  } = useShopStatus()
  // @ts-ignore
  const { i18nName, shopCode = '' } = shopStatusInfo || {}

  const handleToViewShop = () => {
    owlReportMetrics({
      [CUSTOM_METRICS.JumpNum.KEY]: 1,
    })
    KNB && KNB.openPage({
      url: SAILORPARTNER_SHOP_CHOICE, query: { notitlebar: 1 },
      success () {
        owlReportMetrics({
          [CUSTOM_METRICS.JumpSunccess.KEY]: 1,
        })
      },
    })
  }

  const handleToViewStatus = () => {
    owlReportMetrics({
      [CUSTOM_METRICS.JumpNum.KEY]: 1,
    })

    jumpTo(`${getHost()}/web/app/shop#/businessStatus`, {
      onSuccess () {
        owlReportMetrics({
          [CUSTOM_METRICS.JumpSunccess.KEY]: 1,
        })
      },
    })

    lxMC(LvPoint.bid.ShopStatusSet, LvPoint.cid.Index_BusinessTime)
  }

  useEffect(() => {
    const ContainerDom = typeof container === 'string' ? document.getElementById(container) : container
    if (!ContainerDom) return

    const _top = ScrollDomRef.current?.getBoundingClientRect?.()?.top || 80
    // const radius = Number(window.getComputedStyle(BorderRadiusDomRef.current).getPropertyValue('border-top-left-radius')
    //   .replace('px', '')) || 0
    const paddingTop = Number(window.getComputedStyle(ShopNameDomRef.current).getPropertyValue('padding-top')
      .replace('px', ''))

    const scrollHandler = () => {
      if (!(ShopNameDomRef.current &&
        StatusBoxDomRef.current &&
        StatusTagDomRef.current
        // BorderRadiusDomRef.current
      )) return

      const scrollHeight = ContainerDom?.scrollTop || 0

      const { top: shopNameTop, bottom: titleBottom } = ShopNameDomRef.current.getBoundingClientRect()
      const { height: statusHeight, bottom: statusBottom, top: statusTop } = StatusBoxDomRef.current.getBoundingClientRect()
      const { width: statusWidth1 } = StatusTagDomRef.current.getBoundingClientRect()

      function animate () {
        if (shopNameTop < _top) {
          const rate = (_top - shopNameTop) / _top
          // let _radius = parseFloat(((1 - rate) * radius).toFixed(2))
          // _radius = _radius < 0 ? 0 : _radius
          // if (_radius) {
          //   ScrollDomRef.current.style.borderRadius = `${_radius}px ${_radius}px 0 0`
          // }
          const _height = parseFloat((rate * (safeTop - paddingTop)).toFixed(2))
          if (safeTop && (_height >= safeTop - 12)) {
            HeightDomRef.current.style.height = `${safeTop - 12}px`
          } else {
            HeightDomRef.current.style.height = `${_height}px`
          }
        }
        if (scrollHeight <= 2) {
          // ScrollDomRef.current.style.borderRadius = '20px 20px 0 0'
          HeightDomRef.current.style.height = 0
          ShpoIdDomRef.current.style.display = 'block'
          setShowCodeOnly(false)
        } else {
          ShpoIdDomRef.current.style.display = 'none'
          setShowCodeOnly(true)
        }
        if (statusTop <= titleBottom) {
          let _rate = parseFloat((1 - (statusBottom - titleBottom) / statusHeight).toFixed(2))
          _rate = _rate > 1 ? 1 : _rate
          StatusDomRef.current.style.opacity = _rate
          StatusDomRef.current.style.width = `${statusWidth1 * _rate}px`
        } else if (scrollHeight <= 2) {
          StatusDomRef.current.style.opacity = 0
          StatusDomRef.current.style.width = 0
        }
      }

      raf(animate)
    }

    ContainerDom.addEventListener('scroll', scrollHandler)

    scrollHandler()

    return () => ContainerDom.removeEventListener('scroll', scrollHandler)
  }, [container])

  useEffect(() => {
    console.log('More appear subscribe, start', new Date())
    localStorage.setItem('MoreAppearstart', 'start' + new Date())
    const res = KNB && KNB.subscribe({
      action: 'appear',
      handle: function () {
        console.log('More appear subscribe, handle', new Date())
        localStorage.setItem('MoreAppearhandle', 'handle' + new Date())
        updateShopInfo()
      },
      success: function (data) {
        console.log('More appear subscribe, success', new Date())
        localStorage.setItem('MoreAppearsuccess', 'success' + new Date())
      },
      fail: function () {
        console.log('More appear subscribe, fail', new Date())
        localStorage.setItem('MoreAppearfail', 'fail' + new Date())
      },
    })
    const { subId } = res || {}
    return () => {
      KNB && KNB.unsubscribe({
        action: 'appear', // 取消该所有事件的订阅；慎用，会影响所有对该事件的订阅
        subId, // 取消 subId 对应事件的订阅
        success: function () {},
      })
    }
  }, [])

  return (
    <div
      className="rounded-tl-[20px] rounded-tr-[20px] overflow-hidden relative"
      ref={ScrollDomRef}
    >
      {/* 真实的白色圆角背景 */}
      {/* <div className="absolute w-full h-6 rounded-tl-[20px] rounded-tr-[20px]" ref={BorderRadiusDomRef} /> */}
      <Affix
        topOffset={0}
        target="#ShopContainer"
        relativeElementSelector="#ShopContainer"
        affixStyle={{
          boxShadow: '0 12px 12px -12px rgba(0,0,0,0.1)',
          backgroundColor: '#fff',
        }}
      >
        <div ref={ShopNameDomRef} className="pt-3">
          <div ref={HeightDomRef} />
          <div className="font-KeeTa-Bold text-xl px-4 py-2 flex items-center" onClick={handleToViewShop}>
            {/* 门店名称状态提示 */}
            <div ref={StatusDomRef}>
              <div className="w-5" ref={StatusTagDomRef}>
                <div className={`w-[10px] h-[10px] rounded-xl mr-2 ${statusClassname}-bg`} />
              </div>
            </div>
            <div className="max-w-[80%] flex">
              {showCodeOnly ? <div className="flex items-center overflow-hidden">
                {shopCode
                  ? <div className="flex-1 flex overflow-hidden">(<span className="text-ellipsis truncate flex-1">{shopCode}</span>)</div>
                  : <div className="flex-1  text-ellipsis truncate">{i18nName || '--'}</div>
                }
                <div className="font-Keeta-Regular text-base text-gray px-2 flex items-center">
                  ID: {getLoginShopid()}
                </div>
              </div> : <>
                <div className="text-ellipsis truncate">{i18nName || '--'}</div>
                {shopCode ? <div className="max-w-[70%] shrink-0 flex">(<span className="text-ellipsis truncate flex-1">{shopCode}</span>)</div> : null}
              </>}

            </div>
            <div className="flex items-center">
              <Icon name="icon-xialajiantou-zhongyaoyouxianji" className={`${isRTL() ? 'mr-2' : 'ml-2'} text-base`} />
            </div>
          </div>
          <div ref={ShpoIdDomRef} className="font-Keeta-Regular text-base text-gray px-4 pb-2 flex items-center">
            ID: {getLoginShopid()}
          </div>
        </div>
      </Affix>

      <div className="bg-bgGray overflow-hidden" ref={StatusBoxDomRef}>
        <div
          className={`flex items-center justify-between rounded-lg px-3 py-2 mb-2 mx-2 ${statusClassname}-area`}
          onClick={handleToViewStatus}
        >
          <div className={`${isRTL() ? 'pr-4' : 'pl-4'} relative`}>
            <div className={`w-[10px] h-[10px] rounded-lg circle absolute ${isRTL() ? 'right-0' : 'left-0'} top-[5px] ${statusClassname}-bg`}></div>
            <div className="text-sm font-KeeTa-Bold">{statusText || '--'}</div>
            <div className="text-sm">{extText}</div>
          </div>
          <Icon name="icon-jiantou-xianxing02" className={isRTL() ? 'rotate-180' : ''}  color="#8F8F8F" />
        </div>
      </div>
    </div>
  )
}
